import {EntityBase} from "../../shared/entity/EntityBase";

const MACRO_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    label: { defaultValue: '' },
    value: { defaultValue: {} }
};

class MacroEntity extends EntityBase {
    constructor(data = {}) {
        super(data, MACRO_FIELDS);

        this.errors  = [
            { condition: () => this.label.length <= 0, message: '라벨을 입력하세요.' },
            { condition: () => Object.values(this.value).length <= 0, message: '하나 이상의 매크로를 등록해야합니다.' },
        ];
    }
}

export default MacroEntity;